import { AxiosResponse } from 'axios';
import { ReasonFilterRequest, ReasonRequest } from '@/main/models/request';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IReasonApi {
  abstract getDomain(request:ReasonFilterRequest): Promise<AxiosResponse<Result<ReasonRequest[]>>>;
}
